/**
 * @generated SignedSource<<c023a7d0fdfcb6484f3863c44a691525>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserStatus = "ACTIVE" | "APPEAL" | "BANNED" | "BANNED_PERMANENT" | "INACTIVE" | "PENDING" | "SCHEDULED_FOR_DELETION" | "%future added value";
export type RestrictedStatusGuardQuery$variables = Record<PropertyKey, never>;
export type RestrictedStatusGuardQuery$data = {
  readonly currentUser: {
    readonly status: UserStatus;
  } | null | undefined;
};
export type RestrictedStatusGuardQuery = {
  response: RestrictedStatusGuardQuery$data;
  variables: RestrictedStatusGuardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RestrictedStatusGuardQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RestrictedStatusGuardQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b1c68fb7552d3dc1c9b643505df290c0",
    "id": null,
    "metadata": {},
    "name": "RestrictedStatusGuardQuery",
    "operationKind": "query",
    "text": "query RestrictedStatusGuardQuery {\n  currentUser {\n    status\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a6793ab764141b7d76ac46959c21271b";

export default node;
